import {css, StyleSheet} from 'aphrodite';
import moment from 'moment';
import React from 'react';

import {InternalLink as InternalLinkType} from 'notebook/mediocre/MediocreConstants';
import InternalLink from 'notebook/mediocre/mentions/InternalLink';
import * as DateUtil from 'util/DateUtil';

interface DateValueProps {
  dateValue: moment.MomentInput;
  canHighlight?: boolean;
}

export default function DateValue({dateValue, canHighlight = false}: DateValueProps): JSX.Element {
  const internalLink: InternalLinkType = {
    iconId: 'format-calendar',
    name:
      dateValue != null && dateValue !== ''
        ? DateUtil.readableTime(dateValue, {showTime: false})
        : 'Invalid Date',
  };
  return <InternalLink internalLink={internalLink} className={css(canHighlight && styles.highlightable)} />;
}

const styles = StyleSheet.create({
  highlightable: {
    userSelect: 'unset',
  },
});
